import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../components/loading-overlay/loading-overlay";
import { useQuotationPopupState } from "../../hooks/use-app-state";
import { QuotationPopupResetForm } from "../../redux/quotation-popup/actions/default";
import CannotOfferThisProductPopup from "../cannot-offer-this-product-popup/cannot-offer-this-product-popup";
import CustomerAlreadyHasPolicyPopup from "../customer-already-has-policy-popup/customer-already-has-policy-popup";
import { QuotationPopupForm } from "./components/form";
import "./quotation-popup.scss";

const QuotationPopup: React.FC = () => {
    const dispatch = useDispatch();
    const submitting = useQuotationPopupState<boolean>(["form", "submitting"]);
    useEffect(() => dispatch(new QuotationPopupResetForm().create()), []);
    return (
        <div className="quotation-popup" data-testid="quotation-popup">
            <QuotationPopupForm />
            <LoadingOverlay show={submitting} showPercentage={true} />
            <CustomerAlreadyHasPolicyPopup />
            <CannotOfferThisProductPopup />
        </div>
    );
};

export default QuotationPopup;
